// @ts-strict-ignore
import type { ActionContext } from 'vuex'

import type { ActionClass, ContextState, Filter } from '../../../models'

import { FilterTypeEnum } from '../../../enums'

import { CONTEXT_CONSTS } from '../../../store/context/context.consts'

export class ClearFiltersAction implements ActionClass {
  static execute(
    this: void,
    { dispatch, getters }: ActionContext<ContextState, any>,
  ): Promise<void> {
    const enabledFilters: Record<string, Filter> = getters[CONTEXT_CONSTS.getters.enabledFilters]
    const selectedValues = {}
    Object.values(enabledFilters).forEach((filter: Filter) => {
      if (!filter.config.mandatory) {
        selectedValues[filter.config.id] = {
          [FilterTypeEnum.DATE]: [undefined, undefined],
          [FilterTypeEnum.DATE_RANGE]: [undefined, undefined],
          [FilterTypeEnum.REALTIME]: undefined,
          [FilterTypeEnum.REGULAR]: [],
        }[filter.config.type]
      }
    })
    return dispatch(CONTEXT_CONSTS.actions.setFiltersSelectedValues, selectedValues)
  }
}
